export default __webpack_public_path__ + "static/media/cityflows_logo.b3f583da.svg";